<script setup lang="ts">
import { computed, type PropType, ref } from 'vue';
import { useRouter } from 'vue-router';
import type { PlantJson } from '@/data/plants/PlantJson.ts';
import { i18n } from '@/i18n.js';

const props = defineProps({
  selectedRow: {
    type: Object as PropType<{ plant: PlantJson }>,
  },
});

const contextMenu = ref();
const router = useRouter();
const routeDescription = computed(() => {
  return {
    name: 'SinglePlant',
    params: {
      plantId: props.selectedRow?.plant.id,
    },
  };
});

const contextMenuItems = ref([
  {
    label: i18n.global.t('global.open'),
    icon: 'pi pi-arrow-right',
    command: () => router.push(routeDescription.value),
  },
  {
    label: i18n.global.t('global.open_new_window'),
    icon: 'pi pi-external-link',
    command: () => {
      const routeData = router.resolve(routeDescription.value);
      window.open(routeData.href);
    },
  },
]);

defineExpose({ contextMenu });
</script>

<template>
  <ContextMenu ref="contextMenu" :model="contextMenuItems"/>
</template>

<style scoped>

</style>